import React, { FunctionComponent } from 'react';
import Link, { ILinkProps } from '../../components/Link/Link';

const HomeLink: FunctionComponent<ILinkProps> = (props) => {
    return <Link {...props} path={`/`} />;
};

export default HomeLink;
